import _ from "lodash";
import {
  DOWNLOAD_CHUNKS_FILES,
  DOWNLOAD_DATA_EMPTY,
  DOWNLOAD_EMPTY,
  DOWNLOAD_ERROR,
  DOWNLOAD_RETRY,
  DOWNLOAD_START,
  DOWNLOAD_UPDATE,
  EMPTY_DATA_ACTIVE_DOWNLOAD,
  HANDLE_CANCEL_DOWNLOAD_LIST,
  HANDLE_DEFAULT_LIST_DOWNLOAD_HISTORY,
  HANDLE_IS_DOWNLOADING,
  HANDLE_IS_FETCHING_HISTORY,
  HANDLE_ITEM_CANCEL_FROM_DOWNLOAD,
  HANDLE_MINE_OR_ALL,
  HANDLE_REFRESH_DOWNLOAD_HISTORY,
  HANDLE_SHOW_MULTIPLE_DOWNLOAD,
  HANDLE_SHOW_PROGRESS_INDICATOR,
  RESUME_DOWNLOAD_CANCEL,
  RESUME_DOWNLOAD_SHOW,
  SET_DOWNLOAD_FOLDER,
  SET_DOWNLOADS_HISTORY
} from '../constants/download-types';
import initialState from '../store/initial-state';

export default (state = initialState.downloads, action) => {
  switch (action.type) {
    case DOWNLOAD_START:
      return {
        ...state,
        data: [...state.data, action.payload]
      }

    case DOWNLOAD_UPDATE:
      return {
        ...state,
        data: action.payload.state === 'success'
          ? state.data.filter(r => r.uuid !== action.payload.uuid)
          : state.data.map(r => {
            return r.uuid === action.payload.uuid
              ? { ...r, state: 'error' }
              : { ...r }
          })
      }

    case DOWNLOAD_DATA_EMPTY:
      return {
        ...state,
        data: []
      }

    case DOWNLOAD_RETRY:
      return {
        ...state,
        data: action.payload
      }

    case DOWNLOAD_ERROR:
      return {
        ...state,
        data: state.data.map(r => {
          return {
            ...r,
            status: r.id === action.payload
              ? 'error'
              : r.status
          }
        })
      }

    case SET_DOWNLOAD_FOLDER:
      return {
        ...state,
        isDownloadFolder: action.payload.isDownloadFolder,
      }

    case HANDLE_SHOW_PROGRESS_INDICATOR:
      return {
        ...state,
        showProgressIndicator: action.payload.showProgressIndicator,
      }

    case EMPTY_DATA_ACTIVE_DOWNLOAD: {
      return {
        ...state,
        dataActiveDownload: [],
      }
    }

    case HANDLE_CANCEL_DOWNLOAD_LIST: {
      return {
        ...state,
        cancelDownloadList: action.payload.cancelDownloadList
      }
    }

    case HANDLE_ITEM_CANCEL_FROM_DOWNLOAD: {
      return {
        ...state,
        itemCancelFromDownload: action.payload.itemCancelFromDownload,
      }
    }

    case HANDLE_DEFAULT_LIST_DOWNLOAD_HISTORY: {
      return {
        ...state,
        defaultListDownloadHistory: action.payload.defaultListDownloadHistory,
      }
    }

    case SET_DOWNLOADS_HISTORY: {
      return {
        ...state,
        downloadHistory: action.payload.downloadHistory,
      }
    }

    case HANDLE_IS_FETCHING_HISTORY: {
      return {
        ...state,
        isFetchingHistory: action.payload.isFetchingHistory,
      }
    }

    case HANDLE_IS_DOWNLOADING: {
      return {
        ...state,
        isDownloading: action.payload.isDownloading,
      }
    }

    case HANDLE_MINE_OR_ALL: {
      return {
        ...state,
        mine: action.payload.mine
      }
    }

    case HANDLE_SHOW_MULTIPLE_DOWNLOAD: {
      return {
        ...state,
        showMultipleDownload: action.payload.showMultipleDownload,
      }
    }

    case HANDLE_REFRESH_DOWNLOAD_HISTORY: {
      return {
        ...state,
        refreshDownloadHistory: action.payload.refreshDownloadHistory,
      }
    }

    case RESUME_DOWNLOAD_SHOW:
      return {
        ...state,
        showResumeDownload: true,
        showResumeDownloadId: action.payload
      }

    case RESUME_DOWNLOAD_CANCEL:
      return {
        ...state,
        showResumeDownload: false,
        showResumeDownloadId: null
      }

    case DOWNLOAD_EMPTY:
      return {
        ...state,
        data: [],
        data_chunks: {},
        downloadHistory: [],
        showResumeDownload: false,
        showResumeDownloadId: null
      }
    case DOWNLOAD_CHUNKS_FILES:
      const current_value = state.data_chunks[action.payload.uuid] || {current: 0, total: action.payload.total, finalized: false }
      const current = current_value.current + action.payload.current
      
      const updated_data_chunks = _.set(
        {...state.data_chunks}, 
        action.payload.uuid, 
        { 
          current,
          total: action.payload.total,
          finalized: current === action.payload.total,
        })
      
      return {
        ...state,
        data_chunks: updated_data_chunks
      }

    default: return { ...state }
  }
}
